export default "__VITE_ASSET__d$se3NC5__"